export const UPDATELIST = '/updatelist'

// commitment 获取司机信息
export const commitmentApi = '/api/driverInfo/signPledge'
//日流水
export const dayInConmeListApi = '/api/driverInfo/dayIncomeList'
//发送验证码
export const checkCodeApi = '/api/driverUser/checkCode/'
//邀请接口 invite
export const invActApi = '/api/driverUser/invAct'
//邀请信息
export const invActRewardApi = '/api/driverUser/invActReward'
//月流水
export const monthIncomeListApi = '/api/driverInfo/monthIncomeList'
//新用户
export const inviteeRewardDescApi = '/api/driverUser/inviteeRewardDesc'
//登陆
export const loginApi = '/api/driverUser/login'
//体现规则
export const CashRuleApi = '/api/order/orderCashRule'
// 查询车队长
export const fleetDriverInfoApi = '/api/fleet/queryFleetCaptainOnlineInfo'
// 分页查询
export const fleetPageApi = '/api/fleet/queryFleetPage'
// 队长移除
export const leaderDelApi = '/api/fleet/removeDriver'
// 车队信息
export const fleetInfoApi = '/api/fleet/queryFleetInfo'
// 流水分页
export const RewardAmountApi = '/api/fleet/queryRewardAmount'
// 车队邀请链接
export const fleetInviteApi = '/api/driverUser/fleetLink'
// 车队活动完成情况
export const fleetActivityApi = '/api/fleetActivity/query'
// 车队奖励历史
export const fleetActHistoryApi = '/api/fleetActivity/history'
// getcsh 城市
export const loginCityApi = '/api/driverTask/queryCity'
//查询安全专线
export const getSecureLineTelephone = '/api/system/getSecureLineTelephone'
// 查询司机的防疫信息
export const queryDriverAntiepidemic = '/api/antiepidemic/queryDriverAntiepidemic'
// 新增防疫信息
export const addDriverAntiepidemic = '/api/antiepidemic/addDriverAntiepidemic'
// 文件上传
export const fileUpload = '/api/file/upload'
//查询垫付规则
export const queryAdvanceRule = '/api/bill/queryAdvanceRule'
//查询下载地址
export const appDownload = '/api/appDownload/'
//查询免佣卡列表
export const freeCardList = '/api/freeCard/freeCardList'
//购买免佣卡
export const freeCardBuy = '/api/freeCard/buy/'
//司机余额
export const accountBalance = '/api/account/balance'
//账户流水列表
export const accountBills = '/api/account/bills'
//提现
export const accountWithdraw = '/api/account/withdraw'


